import { createFileRoute } from '@tanstack/react-router';
import { StepRecordingPage } from '@/pages/processes/recording/StepRecordingPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';

export const Route = createFileRoute('/$slug/processes/recording/step-recording/$recordingId')({
  loader: createEntityBreadcrumbLoader('stepRecording', 'recordingId'),
  component: StepRecordingRoute
});

// Remount on recordingId change so the per-recording pending-write buffer in
// useProcessRecording cannot leak staged text from one recording onto another:
// a param-to-param navigation would otherwise reuse the same hook instance (and
// its buffer) while rebinding the write closure to the new recording id.
function StepRecordingRoute() {
  const { recordingId } = Route.useParams();
  return <StepRecordingPage key={recordingId} />;
}
